import "./SubNavMobile.scss";

import React, { useState } from "react";

import { SubNavigationMenusData } from "design-system/shared/models/app-data-model";

import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionSummary,
  Box,
  Typography
} from "@mui/material";

import DropdownMenuMobile from "../shared/dropdown-menu-mobile/DropdownMenuMobile";
import { getContentHubDamAsset } from "../../../shared/utils/get-contenthub-dam-asset";
import PhLink from "design-system/shared/components/ph-link/ph-link";

export type SubNavMobileProps = {
  subNavigationMenus: SubNavigationMenusData;
};

const SubNavMobile: React.FC<SubNavMobileProps> = ({ subNavigationMenus }: SubNavMobileProps) => {
  const [isSubNavOpen, setIsSubNavOpen] = useState(false);

  const handleSubNavClick = () => setIsSubNavOpen((isSubNavOpen) => !isSubNavOpen);

  const subNavMenus = subNavigationMenus?.main_navigation_items && subNavigationMenus?.main_navigation_items.map((navItem, index) => {
    return navItem.reference.length > 0 && 'modular_blocks' in navItem.reference[0] ?
      <DropdownMenuMobile navItem={navItem} subnavIndex={index} key={index} /> :
      <PhLink
        className='text'
        key={navItem.title}
        href={navItem.reference[0]?.url || getContentHubDamAsset(navItem.reference[0]?.contenthub_asset)?.url || '/'}
      >{navItem.title}</PhLink>;
  });

  const subNavMenusRight = subNavigationMenus?.right_nav && subNavigationMenus.right_nav.map((navItem, index) => {
    if (navItem.button && navItem.button.reference && navItem.button.reference.length > 0) {
      return navItem.button.reference.length > 0 ?
        <PhLink
          className='text'
          href={navItem.button.reference[0]?.url || getContentHubDamAsset(navItem.button.reference[0]?.contenthub_asset)?.url || '/'}
        >{navItem.button.label}</PhLink> :
        null; // Ensure a return value for each iteration
    }
    return null; // Ensure a return value for each iteration
  });

  return (
    <Accordion disableGutters expanded={isSubNavOpen} sx={{ zIndex: '9'}} className='sub-nav-mobile'>
      <AccordionSummary
        expandIcon={<ExpandMore className='expand-icon'/>}
        aria-controls='subnav-menu'
        className='subnav-menu-header'
        onClick={handleSubNavClick}
        data-testid="subnav-menu"
      >
        <Typography className='subnav-title'>
          {subNavigationMenus?.title}
        </Typography>
      </AccordionSummary>
      <Box className="subnav-menus">
        {subNavMenus}
        {subNavMenusRight}
      </Box>
    </Accordion>
  );
};

export default SubNavMobile;
